import React from "react"
import Dialog from "material-ui/Dialog"
import { FlatButton } from "material-ui"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import { IPosition, IPositionWorkInstructions } from "../../models"
import _ from "lodash"
import AccountStore from "../../stores/AccountStore"
import PositionSelectChip from "../position/PositionSelectChip"

interface IProps {
    handleClose(): void
    handleAdd(position: IPosition): void
    //handleEdit(id: string, unit: IBudgetUnitItem, budgetedNumber: number, demandUnits: number, shiftTemplate: IScheduleShift): void
    positionWorkInstructions?: IPositionWorkInstructions
}

interface IState {
    openConfirmDialog: boolean
    position: IPosition,
    positionList: IPosition[]
}

export default class PositionWorkInstructionsAddDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)

        this.state = {
            openConfirmDialog: false,
            position: undefined,
            positionList: AccountStore.getCurrentAccount().PositionDefinitions,
        }

        autobind(this)
    }

    render() {
        return (
            <Dialog
                open
                autoScrollBodyContent
                title={(!this.props.positionWorkInstructions ? "Add Work Instructions by Position" : "Edit Work Instructions by " + this.props.positionWorkInstructions.PositionName)}
                actions={[
                    <FlatButton
                        data-intercom-target={"AgreementTextDialog-Btn-CloseDialog"}
                        label={strings.CANCEL}
                        secondary
                        onTouchTap={() => { this.props.handleClose() }}
                    />,
                    <FlatButton
                        data-intercom-target={"AgreementTextDialog-Btn-CreateAgreementText"}
                        label={this.props.positionWorkInstructions ? strings.Save : strings.Add}
                        primary
                        onTouchTap={() => {
                            if (this.props.positionWorkInstructions) {
                                //this.props.handleEdit(this.props.positionBudgetItem.Id, this.state.unit, this.state.demandUnits, this.state.budgetedNumber, this.state.shiftTemplate)
                            } else {
                                this.props.handleAdd(this.state.position)
                            }
                        }}
                    />
                ]}
            >
                <div style={{ display: "grid", alignItems: "baseline" }}>
                    <PositionSelectChip
                        usablePositionLabel={strings.Job_Position}
                        usablePositions={this.state.positionList}
                        position={this.state.position}
                        onRequestSave={(position) => {
                            this.setState({position})
                        }}
                    />   
                </div>
            </Dialog>
        )
    }
}
